import { axiosSwagger } from "@/axios";



export const state = {
  // move folder
  moveLocation: {
    loading: false,
    data: [],
  }
}


export const getters = {
}


export const mutations = {
  // MOVE FOLDER
  moveLocationLoading: (state, loading) => {
    state.moveLocation.loading = loading;
  },
  setMoveLocationData: (state, data) => {
    state.moveLocation.data = data;
  },
}


export const actions = {
  // MOVE FOLDER
  async readMoveLocation({ commit }, id) {
    commit("moveLocationLoading", true);

    const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

    if(id !== null){
      return await axiosSwagger
        .get(`/api/FileLocation/Child/${id}/${userData?.deliveryUnit?.id}`)
        .then((response) => {
          commit("setMoveLocationData", response.data);
          commit("moveLocationLoading", false);

          return response;
        })
        .catch(() => {
          commit("moveLocationLoading", false);
        });
    }
    else{
      return await axiosSwagger
        .get(`/api/FileLocation/My/${userData?.deliveryUnit?.id}`)
        .then((response) => {
          commit("setMoveLocationData", response.data);
          commit("moveLocationLoading", false);

          return response;
        })
        .catch(() => {
          commit("moveLocationLoading", false);
        });
    }
  },
  // eslint-disable-next-line no-unused-vars
  async readMoveLocationByParentId({ commit }, id) {
    return await axiosSwagger
      .get(`/api/FileLocation/${id}`)
      .then((response) => {
        return response;
      });
  }
}

